$.fn.Cursor = function(selector_class, cursor_type)
{
  var self = this;
  self.selector_class = selector_class;
  self.cursor_type = cursor_type;
  self.el = {
    circle: self.find('#cursor-circle'),
    triangle: self.find('#cursor-triangle'),
  }
  self.status = {
    first_move: true,
    visible: false,
    direction: 'right',
  };

  self.mouseenter_handler = function(e){
    $('.wrapper').addClass('has-cursor');
    self.status.visible = true;
    self.check(e);
  };

  self.mouseleave_handler = function(e){
    $('.wrapper').removeClass('has-cursor');
    self.status.visible = false;
    self.check(e);
  };

  self.mousedown_handler = function(){
    self.addClass('mousedown');
  };

  self.mouseup_handler = function(){
    self.removeClass('mousedown');
  };

  self.click_handler = function(){
    if (self.cursor_type == "slider"){
      let swiper = $(self.selector_class).data('swiper');
      if (swiper){
        if (self.status.direction == 'left'){
          swiper.slidePrev();
        } else {
          swiper.slideNext();
        }
      }
    }
  };

  self.check = function(e){
    if (self.status.visible){
      if (self.cursor_type == "slider" && e.clientX < $(window).width() / 2){
        self.addClass('left');
        self.status.direction = 'left';
      } else {
        self.removeClass('left');
        self.status.direction = 'right';
      }
      self.css({
        visibility: 'visible',
        top: e.clientY,
        left: e.clientX,
      });
    } else {
      self.css({
        visibility: 'hidden',
      });
    }
  };

  // /*
  // * Vimeo player
  // */
  // self.mouseenter_video = function(e){
  //   $('.wrapper').addClass('has-cursor');
  //   self.status.visible = true;
  //   self.check_video(e);
  // };

  // self.mouseleave_video = function(e){
  //   $('.wrapper').removeClass('has-cursor');
  //   self.status.visible = false;
  //   self.check_video(e);
  // };

  // self.check_video = function(e){
  //   if (self.status.visible){
  //     // self.el.circle.show();
  //     self.removeClass('left');
  //     self.status.direction = 'right';
  //     self.css({
  //       visibility: 'visible',
  //       top: e.clientY,
  //       left: e.clientX,
  //     });
  //   } else {
  //     // self.el.circle.hide();
  //     self.css({
  //       visibility: 'hidden',
  //     });
  //   }
  // };

  // self.mousedown_video = function(){
  //   self.addClass('mousedown');
  // };
  //
  // self.mouseup_video = function(){
  //   self.removeClass('mousedown');
  // };

  return function()
  {
    // self.el.circle.hide();

    /* Slider */
    $(self.selector_class).one('mousemove', function(e){
      if (self.status.first_move && !self.status.visible){
        self.status.first_move = false;
        self.mouseenter_handler(e);
      }
    });
    $(document).on('mouseenter mouseover', self.selector_class, self.mouseenter_handler).
      on('mouseleave mouseout', self.selector_class, self.mouseleave_handler).
      on('mousemove', self.selector_class, self.check).
      on('mousedown', self.selector_class, self.mousedown_handler).
      on('mouseup', self.mouseup_handler).
      on('click', self.selector_class, self.click_handler);
    self.check();

    // /* Video player */
    // $('.play-zone').one('mousemove', function(e){
    //   if (self.status.first_move && !self.status.visible){
    //     self.status.first_move = false;
    //     self.mouseenter_video(e);
    //   }
    // });
    // $(document).on('mouseenter mouseover', '.play-zone', self.mouseenter_video).
    //   on('mouseleave mouseout', '.play-zone', self.mouseleave_video).
    //   on('mousemove', '.play-zone', self.check_video).
    //   on('mousedown', '.play-zone', self.mousedown_video).
    //   on('mouseup', self.mouseup_video);
    // self.check_video();

    return self;
  }();
};
